<script lang="ts">
	import type { HistoryPoint } from "./HistoryPoint.js";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import translations from "./HistoryCard.translations.json";
	import { getTranslate } from "../utils/getTranslate.js";
	import Icon from "./Icon.svelte";
	import arrowDown from "../../../core/assets/icons/arrow-down.svg?raw";
	import { flyInOnScroll } from "../utils/flyInOnScroll.js";
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let point: HistoryPoint;

	const translate = getTranslate(translations);
</script>

<div
	use:flyInOnScroll
	class="group row-span-2 grid grid-rows-subgrid gap-20 lg:col-span-2 lg:row-span-1 lg:grid-cols-subgrid lg:grid-rows-1"
>
	<div class="relative h-[21.25rem]">
		<StaticPicture
			class="h-full w-full"
			imgClass="w-full h-full object-cover"
			image={point.image}
			height={350}
			width={0}
			alt={point.headline}
		/>

		<div
			class="group absolute inset-0 flex flex-col items-start gap-4 bg-black/50 px-16 py-9 leading-none transition-colors group-hover:bg-transparent"
		>
			<span class="text-2md font-light text-white group-hover:text-gray-200">{translate("milestone")}</span>
			<div class="relative flex-1 border-l-4 border-dotted border-white group-hover:border-gray-200">
				<Icon
					icon={arrowDown}
					class="absolute -bottom-1 -left-0.5 h-8 w-8 -translate-x-1/2 translate-y-1/2 text-white group-hover:text-gray-200"
				/>
			</div>
			<span class="text-4xl font-semibold text-white group-hover:text-gray-200">{nbspify(point.year.toString())}</span>
		</div>
	</div>
	<div
		class="flex flex-col-reverse justify-between gap-4 border-b border-black py-6 lg:flex-col lg:border-b-0 lg:border-t"
	>
		<span class="text-[1.125rem] font-light lg:text-[1.1875rem]">{nbspify(point.perex)}</span>
		<span class="lg:text-2lg text-[1.75rem] font-bold">{nbspify(point.headline)}</span>
	</div>
</div>
